export * from './tracking-constants';
export const LOGIN_PREVIEW_LINK = 'https://login.preview.xing.com';
export const PREVIEW_HOSTNAME = 'preview.xing.com';
export const LOGIN_PRODUCTION_LINK = 'https://login.xing.com';
export const XINGBOX_IDENTIFIER = '.kenv.xing.com';
